export const SET_ALL_LEARNING_PATH_LIST = 'SET_ALL_LEARNING_PATH_LIST';

export const setAllLearningPathList = (options) => {
    return {
        type: SET_ALL_LEARNING_PATH_LIST,
        payload: options,
    };
};